module.exports = "../images/fishing-lure-1.png?v=6cd5630";